import { render } from "./uploadpdf.vue?vue&type=template&id=a20fd7ee"
import script from "./uploadpdf.vue?vue&type=script&lang=js"
export * from "./uploadpdf.vue?vue&type=script&lang=js"

import exportComponent from "/Users/arvindersingh/Desktop/projects/parsoftwares/rt-backend/backend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__